module.exports = __webpack_public_path__ + "media/34.ab02cdb1.mp3";